import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { OrderManager } from './OrderManager';
import { StaffManager } from './StaffManager';
import InventoryManager from './InventoryManager';
import { useStore } from '../../app/stores/rootStore';

export default observer(function AdminDashboard() {
    const { bookingStore, productsStore, userStore } = useStore();
    const [activeTab, setActiveTab] = useState<'orders' | 'inventory' | 'staff'>('orders');

    useEffect(() => {
        bookingStore.loadAll(); // Admin view: load all orders
        productsStore.loadAll(); 
    }, [bookingStore, productsStore]);

    return (
        <section className="py-5 bg-light min-vh-100">
            <div className="container mt-5">
                <div className="row g-4">
                    {/* Sidebar Navigation */}
                    <div className="col-lg-3">
                        <div className="card border-0 shadow-sm p-4 bg-white rounded-4 sticky-top">
                            <h5 className="fw-bold mb-4">Management</h5>
                            <ul className="nav flex-column gap-2">
                                <li className="nav-item">
                                    <button className={`nav-link w-100 text-start rounded-3 border-0 ${activeTab === 'orders' ? 'bg-primary text-white' : 'bg-transparent text-dark'}`} 
                                            onClick={() => setActiveTab('orders')}>
                                        <i className="bi bi-cart-check me-2"></i> Orders
                                    </button>
                                </li>
                                <li className="nav-item">
                                    <button className={`nav-link w-100 text-start rounded-3 border-0 ${activeTab === 'inventory' ? 'bg-primary text-white' : 'bg-transparent text-dark'}`} 
                                            onClick={() => setActiveTab('inventory')}>
                                        <i className="bi bi-box-seam me-2"></i> Inventory
                                    </button>
                                </li>
                                {/* Only Super Admin can see Staff Management */}
                                {userStore.roleLevel >= 2 && (
                                    <li className="nav-item border-top mt-2 pt-2">
                                        <button className={`nav-link w-100 text-start rounded-3 border-0 ${activeTab === 'staff' ? 'bg-danger text-white' : 'bg-transparent text-dark'}`} 
                                                onClick={() => setActiveTab('staff')}>
                                            <i className="bi bi-shield-lock me-2"></i> Staff & Roles
                                        </button>
                                    </li>
                                )}
                            </ul>
                        </div>
                    </div>

                    {/* Main Content Area */}
                    <div className="col-lg-9">
                        <div className="card border-0 shadow-sm p-4 bg-white rounded-4">
                            {activeTab === 'orders' && <OrderManager />}
                            {activeTab === 'inventory' && <InventoryManager />}
                            {activeTab === 'staff' && <StaffManager />}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
});